<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-data-table
                    :fields="fields"
                    :repository="repositories.paciente"
                    :disabled-button-search="true"
                    :tbody-tr-class="rowClass"
                    class="tabela-resultado"
                    ref="DataTable"
                    sort-by="nome"
                >
                    <template v-slot:cell(nome)="{ item }">
                        {{ item.nome }}

                        <template v-if="item.nomeSocial">
                            <template v-if="item.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                                <strong>({{ item.nomeSocial }})</strong>
                            </template>

                            <template v-else>
                                <strong>({{ item.nomeSocial }})</strong>
                            </template>
                        </template>

                        <span
                            v-if="item.obitoEm"
                            class="ml-1"
                            title="Óbito"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="cross" />
                        </span>

                        <span
                            v-if="item.classificacaoId == enums.classificacao.OUTRO_MUNICIPIO"
                            class="ml-1"
                            title="Não munícipe"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="map-pin" />
                        </span>

                        <span
                            v-if="item.classificacaoId == enums.classificacao.PROVISORIO || item.subclassificacaoId == enums.subclassificacao.TEMPORARIO"
                            class="ml-1"
                            title="Provisório e/ou Temporário"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="hourglass-half" />
                        </span>
                    </template>

                    <template v-slot:cell(dataNascimento)="row">
                        {{ row.value | formatDate }}
                    </template>

                    <template v-slot:cell(cpf)="row">
                        {{ row.value | formatCpf }}
                    </template>

                    <template v-slot:cell(cns)="row">
                        {{ row.value | formatCns }}
                    </template>

                    <template v-slot:cell(actions)="{ item }">
                        <rkm-button
                            @click.stop="search(item)"
                            color="primary"
                            title="Visualizar"
                            small
                        >
                            <rkm-icon icon="search" />
                        </rkm-button>
                    </template>
                </rkm-data-table>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-3">
            <rkm-col>
                <p class="m-0">
                    <rkm-icon icon="cross" /> Linhas em <span class="danger">vermelho</span> representam pacientes em óbito.<br>
                    <rkm-icon icon="map-pin" /> Linhas em <span class="brown">marrom</span> representam pacientes não munícipes.<br>
                    <rkm-icon icon="hourglass-half" /> Linhas em <span class="orange">laranja</span> representam pacientes provisórios ou temporários.
                </p>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Mixins.
import { repository, error, stringCase } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import classificacao from '@/enums/cadastro/paciente/classificacao'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'

// Vuex.
import {mapActions} from 'vuex'

export default {
    created() {

        this.repositories = {
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        }
    },
    data: () => ({
        fields: [
            {
                name: 'cadastroCidadao.nome',
                key: 'nome',
                label: 'Nome (Nome social)',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroCidadao.nomeSocial',
                key: 'nomeSocial',
                label: 'Nome social',
                searchable: true,
                sortable: true,
                visible: false
            },
            {
                name: 'cadastroCidadao.dataNascimento',
                key: 'dataNascimento',
                label: 'Data de nascimento',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroCidadao.nomeMae',
                key: 'nomeMae',
                label: 'Nome da mãe',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroPaciente.prontuario',
                key: 'prontuario',
                label: 'Prontuário municipal',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroCidadao.cpf',
                key: 'cpf',
                label: 'CPF',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroCidadao.cns',
                key: 'cns',
                label: 'CNS',
                searchable: true,
                sortable: true
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        repositories: {
            paciente: null,
        },
        enums: { preferenciaNome, classificacao, subclassificacao }
    }),
    filters: {
        formatDate: formats.formatDate,
        formatCns: formats.formatCns,
        formatCpf: formats.formatCpf,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        rowClass(item, type) {
            if(item && type === 'row') {
                if (item.obitoEm) {
                    return 'table-danger'
                }
                if (item.classificacaoId == this.enums.classificacao.OUTRO_MUNICIPIO) {
                    return 'table-brown'
                }
                if (item.classificacaoId == this.enums.classificacao.PROVISORIO || item.subclassificacaoId == this.enums.subclassificacao.TEMPORARIO) {
                    return 'table-orange'
                }
            }
        },
        search(item) {

            this.setLoading()

            this.repositories.paciente.validCNS(this.camelObjectKeysToSnakeRecursive({pacienteId: item.id}))
                .then(response => {

                    if (!response.data.additionals.cnsValido && response.data.additionals.avisaCnsTemporarioInvalido) {

                        this.showWarningNotification('Paciente com CNS inválido. Registro não permitido.')
                        return false
                    }

                    if (item.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                        && response.data.additionals.avisaCnsTemporarioInvalido) {

                            const confirm = async () => {

                                this.$nextTick().then(() => this.checkEnderecoAndProceed(item))

                                return false
                            }

                            const msg = `Paciente com cadastro temporário. Deseja continuar?`

                            this.showConfirmation(msg, confirm)

                            return false
                    }

                    if (item.diasCadastroDesatualizado > 0) {

                        const confirm = async () => {

                            this.$nextTick().then(() => this.checkEnderecoAndProceed(item))

                            return false
                        }

                        let msg = `Paciente com cadastro desatualizado há <strong>${item.diasCadastroDesatualizado}</strong>
                            dia(s). Deseja continuar?`

                        if (item.enderecoDesatualizadoBloqueado) {

                            msg = `Paciente com cadastro desatualizado há <strong>${item.diasCadastroDesatualizado}</strong>
                                dia(s). Endereço do usuário também deve ser atualizado. Deseja continuar?`
                        }

                        this.showConfirmation(msg, confirm)

                        return false
                    }

                    this.checkEnderecoAndProceed(item)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        checkEnderecoAndProceed(item) {

            if (item.enderecoDesatualizadoBloqueado) {

                this.showAlert(
                    'O endereço do paciente ainda não foi atualizado pela Base Nacional. Atualize o cadastro para continuar.',
                    'Atenção'
                )

                return
            }

            this.$router.push({ name: 'exame-imagem-agendamento-create', params: { id: item.id } })
        },
    },
    mixins: [ repository, error, stringCase ],
}
</script>

<style scoped>
.danger {
    color: var(--danger);
}

.brown {
    color: #8B5A2B;
}

.orange {
    color: #E67E22;
}

.tabela-resultado >>> .table-orange {
    border-color: #F28C28;
    background-color: #FFE0B2;
}

.tabela-resultado >>> .table-brown {
    border-color: #6F4E37;
    background-color: #D2B48C;
}
</style>